import axios, { AxiosResponse } from 'axios';
import { get, map, range, size } from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import { CSSProperties } from 'react';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Subject } from 'rxjs/Subject';
import { Environment } from '../../../environment/environment';
import { Notification } from '../../../index';
import { LoaderComponent } from '../loader.component';
import { ListResponsePresenterWildcard } from '../presenters/list-response-presenter-wildcard';
import { ResourceModal } from '../resource-modal';
import './file-manager.scss';

// tslint:disable

const buttonRowStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row'
};

export interface FileManagerProps {
    onChanges$?: Subject<any>;
    defaultSelected?: string[];
    multi?: boolean;
    onSelectSuccessful?: any;
}

export class FileManager extends React.Component<FileManagerProps> {
    public state: any = {
        listView: true,
        root: null,
        directories: [],
        files: [],
        selectedDirectories: [],
        selectedFiles: [],
        uploadState: {}
    };

    public filesInUploadProcess = {};
    public clickCounter = 0;
    public clickListener: Subject<any> = new Subject();

    public directoryLoader$: Subject<boolean> = new Subject();
    public fileLoader$: Subject<boolean> = new Subject();
    public combinedLoader$ = combineLatest(
        this.directoryLoader$,
        this.fileLoader$,
        (d: boolean, f: boolean) => (d === f) ? d : true
    );

    componentDidMount() {
        this.fetchDirectories();
        this.fetchFiles();

        if (this.props.defaultSelected) {
            this.setState({
                selectedFiles: this.props.defaultSelected
            });
        }

        this.clickListener.debounceTime(200).subscribe((value: any) => {
            if (value.type === 'file' && value.counter === 1) {
                this.selectFile(value.item);
            }
            // if (value.type === 'file' && value.counter > 1) {
            //     window.open(`/media-item/${value.item.id}`, '_blank')
            // }
            this.clickCounter = 0;
        });

        if (this.props.onChanges$ && this.props.onChanges$.subscribe) {
            this.props.onChanges$.subscribe((value) => {
                this.setState({
                    selectedFiles: value
                });
            });
        }
    }

    handleDirectoryChange(id: number) {
        this.fetchDirectories(id);
        this.fetchFiles(id);
    }

    public async fetchDirectories(id: number = 1) {
        this.directoryLoader$.next(true);

        try {
            const response: AxiosResponse = await axios.get(`${Environment.get('api.base')}/media-category/${id}`, {
                withCredentials: true
            });

            const children: AxiosResponse = await axios.get(`${Environment.get('api.base')}/media-category`, {
                withCredentials: true,
                params: {
                    parent: id,
                    pagination: false
                }
            });

            if (!response.data) {
                throw new Error('no.response');
            }

            const prevDir = {
                id: get(response.data, 'parent.id'),
                '@id': get(response.data, 'parent.@id'),
                title: '..'
            };

            this.setState({
                root: response.data,
                directories: [prevDir, ...get(children.data, 'hydra:member')],
            });
        } catch (err) {
//
        } finally {
            this.directoryLoader$.next(false);
        }
    }

    public async fetchFiles(dir: number = 1) {
        this.fileLoader$.next(true);
        try {
            const response: AxiosResponse = await axios.get(`${Environment.get('api.base')}/media-item`, {
                withCredentials: true,
                params: {
                    category: dir,
                    pagination: false
                }
            });

            if (!response.data) {
                throw new Error('no.response');
            }

            this.setState({
                files: get(response.data, '[hydra:member]', []),
            });
        } catch (err) {
            // console.log(err.message);
        } finally {
            this.fileLoader$.next(false);
        }
    }

    isSelectedFile(id: string) {
        return this.state.selectedFiles.indexOf(id) > -1;
    }

    handleFileClick(item: any) {
        this.clickListener.next({
            type: 'file',
            item: item,
            counter: ++this.clickCounter
        });
    }


    selectFile(item: any) {
        const itemId: string = get(item, '@id');

        if (!this.props.multi) {
            if (this.state.selectedFiles.indexOf(itemId) > -1) {
                this.setState({
                    selectedFiles: []
                })
            } else {
                this.setState({
                    selectedFiles: [itemId]
                })
            }
        } else {
            let index = this.state.selectedFiles.indexOf(itemId);

            if (this.state.selectedFiles.indexOf(itemId) > -1) {
                let items: any = this.state.selectedFiles;

                items.splice(index, 1);

                this.setState({
                    selectedFiles: items
                })
            } else {
                let items: any = this.state.selectedFiles;

                items.push(itemId);
                this.setState({
                    selectedFiles: items
                })
            }
            // handle multi select
        }

        this.handleSelectionChanges();
    }

    handleSelectionChanges() {
        if (this.props.onChanges$ && this.props.onChanges$.subscribe) {
            this.props.onChanges$.next(this.state.selectedFiles);
        }
    }

    public rowFiles(item: any, index: number) {
        const listView = <div
            className={'w-100 directory-item pointer imageItem ' + (this.isSelectedFile(get(item, '@id')) ? ' selected' : '')}
            onClick={() => this.handleFileClick(item)}
            key={index}>
            <img src={get(item, 'images[720_560i]')} width={100} className=""/>
            <span className="name">
                <b>{get(item, 'title')}</b><br/>
                {moment(get(item, 'createdAt')).format('DD/MM/Y H:mm')}
            </span>
        </div>;

        return this.state.listView ? listView : <span/>;
    }

    public async onDirectoryDeleteClick(id: any) {
        const result: boolean = await Notification.delete();

        if (!result) {
            return;
        }

        try {
            this.directoryLoader$.next(true);

            await axios.delete(`${Environment.get('api.base')}/media-category/${id}`, {
                withCredentials: true
            });

        } catch (err) {
            await Notification.error(`Can't delete`, 'Directory is not empty!');
        } finally {
            this.fetchDirectories(this.state.root.id);
        }
    }

    public static DIRECTORY_BUTTON_STYLE: any = {
        right: 0,
        bottom: 0,
        top: 0,
        padding: '0 5px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#fafafa',
        overflow: 'hidden'
    };

    public static DIRECTORY_LABEL_STYLE: any = {
        display: 'flex',
        overflow: 'hidden'
    };

    public rowDirectories(item: any, index: number) {
        if (!get(item, 'id')) {
            return <span key={index}/>;
        }

        return <div className="w-100 directory-item b-solid pointer relative" key={index}>
            <div style={FileManager.DIRECTORY_LABEL_STYLE} onClick={() => this.handleDirectoryChange(item.id)}>
                <i className="icon fa fa-folder"/>
                <span className="name">{get(item, 'title')}</span>
            </div>

            <div className="absolute" style={FileManager.DIRECTORY_BUTTON_STYLE}
                 onClick={() => this.onDirectoryDeleteClick(item.id)}>
                {/* item.title !== '..' && <i className="fa fa-cog pull-right"/> */}
                {item.title !== '..' && <i className="fa font-red fa-trash-o pull-right"/>}
            </div>
        </div>;
    }

    uploadFiles(event: any) {
        const files: FileList = event.target.files;
        range(files.length).forEach((index: number) => {
            const processName = `${index}-${Math.floor(Math.random() * 10000000)}`;
            const file: any = files.item(index);
            const reader: FileReader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadstart = (ev: ProgressEvent) => {
                this.filesInUploadProcess[processName] = {
                    state: 'started',
                    filename: file.name
                };
                this.updateUploadState();
            };
            reader.onloadend = (ev: ProgressEvent) => {
                this.filesInUploadProcess[processName] = {
                    state: 'browserload_end',
                    filename: file.name,
                    percentage: 0
                };
                this.updateUploadState();

                if (this.refs.UPLOADFILEBUTTON) {
                    (this.refs.UPLOADFILEBUTTON as any).value = '';
                }

                this.uploadFileToApi(file.name, (ev.currentTarget as any).result, processName);
            };
            reader.onprogress = (ev: ProgressEvent) => {
                this.filesInUploadProcess[processName] = {
                    state: 'inprogress_browser',
                    filename: file.name,
                    percentage: (ev.loaded / ev.total) * .1
                };
                this.updateUploadState();
            };
            reader.onabort = (ev: ProgressEvent) => {
                this.filesInUploadProcess[processName] = {
                    state: 'aborted',
                    filename: file.name,
                    percentage: 0
                };
                this.updateUploadState();
            };
        });
    }

    public async uploadFileToApi(fileName: string, data: string, processName: string) {
        try {
            await axios.post(`${Environment.get('api.base')}/media-item`, {
                title: fileName,
                media: data,
                category: get(this.state.root, '@id')
            }, {
                withCredentials: true,
                onUploadProgress: (ev: ProgressEvent) => {
                    this.filesInUploadProcess[processName] = {
                        state: 'inprogress_upload',
                        filename: fileName,
                        percentage: ev.loaded / ev.total
                    };
                    this.updateUploadState();
                }
            });

            this.filesInUploadProcess[processName] = {
                state: 'successful',
                filename: fileName,
                percentage: 1
            };
            this.updateUploadState();
        } catch (err) {
            this.filesInUploadProcess[processName] = {
                state: 'aborted',
                filename: fileName,
                percentage: 1
            };
        } finally {
            this.fetchFiles(this.state.root.id);
        }
    }

    updateUploadState() {
        this.setState({uploadState: this.filesInUploadProcess});
    }

    async handleSelect() {
        try {
            this.fileLoader$.next(true);
            const files: any = await Promise.all(this.state.selectedFiles.map(async (f: any) => {
                return (await axios.get(`${Environment.get('api.base')}${f}`, {
                    withCredentials: true
                })).data;
            }));

            this.props.onSelectSuccessful(files);
            this.fileLoader$.next(false);
        } catch (err) {
            // todo  -- handle error
        }
    }

    closeUploads() {
        this.filesInUploadProcess = {};
        this.updateUploadState();
    }

    render() {
        return (
            <div className="">
                <LoaderComponent isLoading$={this.combinedLoader$}/>

                <div className="w-100 directory-header align-items-center">
                    <div className="col-xs-12">
                        <div style={buttonRowStyle}>
                            <input type='file' multiple={this.props.multi} className="hidden" ref={'UPLOADFILEBUTTON'}
                                   onChange={(event: any) => this.uploadFiles(event)}/>
                            <button className="btn btn-xs btn-primary border-radius-0"
                                    onClick={() => $(this.refs.UPLOADFILEBUTTON).trigger('click')}>
                                <span className={'fa fa-plus'}/>
                                <span>&nbsp;File</span>
                            </button>

                            <ResourceModal entity={'__input-prompt'} extClass="btn-xs border-radius-0" title={<span>
                                <span className={'fa fa-plus'}/>
                                <span>&nbsp;URL</span>
                            </span>} config={{title: 'Resource URL', onSubmit: console.log}}/>

                            <ResourceModal
                                entity={'media-category'}
                                extClass="btn-xs border-radius-0"
                                entityId={'create'}
                                onCreateSuccessful={() => this.fetchDirectories(get(this.state.root, 'id'))}
                                config={{
                                    title: 'Resource URL',
                                    onSubmit: console.log,
                                    parent: this.state.root
                                }}
                                title={<span>
                                <span className={'fa fa-plus'}/>
                                <span>&nbsp;Directory</span>
                            </span>}/>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 header-actions text-right">
                        {this.props.onSelectSuccessful && (this.state.selectedFiles.length > 0) &&
                        <button className="btn btn-primary" onClick={() => this.handleSelect()}>select file</button>}
                    </div>
                </div>

                <div className="w-100 manager-wrapper flex row" style={{display: 'flex'}}>
                    <div className="col-xs-12 col-sm-4 col-md-3 directory-wrapper">
                        <ListResponsePresenterWildcard items={this.state.directories}
                                                       row={(item: any, index: number) => this.rowDirectories(item, index)}/>
                    </div>
                    <div className="col-xs-12 col-sm-8 col-md-9 p-0 file-wrapper" style={{minHeight: '700px'}}>
                        <ListResponsePresenterWildcard items={this.state.files}
                                                       row={(item: any, index: number) => this.rowFiles(item, index)}/>
                    </div>
                </div>

                {!!size(this.state.uploadState) && <div className="upload-progress-wrapper">

                    <span className="close-upload fa fa-close" onClick={() => this.closeUploads()}/>

                    <div className="pw-w">
                        {map(this.state.uploadState, (item: any, index: number) => <div className='col-xs-12'
                                                                                        key={index}>
                            <span className="pNumber">
                                <b>{`${Math.floor(item.percentage * 100)}%`} - </b>
                                <span>{item.filename}</span>
                            </span>
                            <div className="progress">
                                <div
                                    className={`progress-bar progress-bar-striped progress-bar-animated ${(item.state === 'aborted') && 'bg-red'}  ${(item.state === 'successful') && 'bg-green'}`}
                                    role={'progressbar'}
                                    aria-valuenow={`${Math.floor(item.percentage * 100)}` as any}
                                    aria-valuemin={0}
                                    aria-valuemax={100} style={{width: `${Math.floor(item.percentage * 100)}%`}}/>
                            </div>
                        </div>)}
                    </div>
                </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/file-manager/file-manager.tsx